import { getEnvVariables } from '../config/getEnvVars'

export const FIREBASE_CONFIG = {
  apiKey: getEnvVariables().FIREBASE_API_KEY,
  authDomain: getEnvVariables().FIREBASE_AUTH_DOMAIN,
  databaseURL: getEnvVariables().FIREBASE_DATABASE_URL,
  projectId: getEnvVariables().FIREBASE_PROJECT_ID,
  storageBucket: getEnvVariables().FIREBASE_STORAGE_BUCKET,
  messagingSenderId: getEnvVariables().FIREBASE_MESSAGING_SENDER_ID,
  appId: getEnvVariables().FIREBASE_APP_ID,
}

export const UNITS_MASTER = 'unitsmaster'
export const INDIVIDUAL_UNITS = 'individualunits'
export const CANCEL_LIST = 'cancellist'
